import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthenticationService, RAFUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UserDetailDialogComponent } from '../user-detail-dialog/user-detail-dialog.component';
import { User } from 'src/app/core/data/entities';
import { InputDialogComponent, SharedModule } from 'src/app/shared/shared.module';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'app-users-overview',
    templateUrl: './users-overview.component.html',
    styleUrls: ['./users-overview.component.scss'],
    standalone: false
})
export class UsersOverviewComponent implements OnInit {
    coops: any;
    entities: User[];
    filter: any;
    processing = false;
    isToastVisible = false;
    validationGroup = 'mainValidationGroup';
    // entity: Entity;
    errorAction = 'saving';

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private auth: AuthenticationService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
        this.filter = {};
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const employees = await this.uow.getEmployees();
        const entities = ((await this.uow.getUserInfos()) as User[]).filter((x) => {
            return x.id !== 1;
        });
        entities.forEach((x) => {
            x.employeeId = null;
            if (!!x.deleted) x.deleted = moment(x.deleted).toDate();
            (x as any).displayRoles = x.roles?.join(' --- ') ?? '';
        });
        this.entities = entities;
        this.appInfo.pleaseWaitHide();
    }
    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!!e.data.deleted) {
                e.rowElement.className = e.rowElement.className + ' employee-gray-grid';
            }
        }
    }
    rowDoubleClick(e) {
        this.open(e.data);
    }

    async open(user?: any) {
        const modalRef = this.modalService.show(UserDetailDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                userId: !!user ? user.id : null
            }
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
            if (result && result.success) {
                await this.getData();
            }
        });
    }

    async delete() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        this.appInfo.pleaseWaitShow();
        const user = await this.uow.users.byId(selectedRow.id) as any;
        user.deleted = new Date();
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
